import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getDebtsDataAction } from '../actions/actions';

const { useLoader: usePaymentHubDebtsLoader, LoaderProvider } = createLoaderImp(
  {
    action: getDebtsDataAction,
  },
);

function PaymentHubDebtsData({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export { PaymentHubDebtsData, usePaymentHubDebtsLoader };
